
function findParentWithClass(element, className, depth) {
    for (var i = 0; i < depth; i++) {
        element = element.parent();
        if (element.hasClass(className)) {
            return element;
        }
    }
    return undefined;
}


module.directive('formField', function($timeout, $parse) {
    return {
        restrict: 'A',
        require: ['ngModel', '?^inlineForm', 'formField'],
        controller: function() {},
        link: function(scope, element, attrs, controllers) {

            var ngModel = controllers[0],
                inlineForm = controllers[1],
                formFieldController = controllers[2],
                wrapper = findParentWithClass(element, 'field', 2),
                additionalCondition,
                refreshTimeout;


            function focusHandler() {
                if (formFieldController.focus) {
                    return formFieldController.focus();
                }
                switch(element[0].tagName.toLowerCase()) {
                    case 'textarea':
                    case 'select':
                    case 'input':
                        element[0].focus();
                        element[0].select();
                        break;
                    default:
                        var input = element.find('input');
                        if (input.length > 0) {
                            input[0].focus();
                            input[0].select();
                        }
                        break;
                }
                return element;
            }

            if (inlineForm && ngModel.$name) {
                inlineForm.registerFocusHandler(ngModel.$name, focusHandler);
            }

            if (attrs.highlightWhen) {
                additionalCondition = $parse(attrs.highlightWhen);
            }

            if (angular.isDefined(attrs.noRequire)) {
                additionalCondition = function() { return false; };
            }

            function shouldHighlight(value) {
                return ngModel.$isEmpty(value) &&
                       (angular.isUndefined(additionalCondition) ||
                        additionalCondition(scope, {value: value}));
            }

            function refreshWrapper() {
                var value = ngModel.$modelValue || ngModel.$viewValue;
                wrapper.toggleClass('empty', !!shouldHighlight(value));
                wrapper.toggleClass('ng-invalid', ngModel.$invalid);
            }

            function scheduleRefresh() {
                $timeout.cancel(refreshTimeout);
                refreshTimeout = $timeout(refreshWrapper, 10);
            }

            if (angular.isDefined(wrapper)) {
                ngModel.$viewChangeListeners.push(scheduleRefresh);
                scope.$watch(function() {return ngModel.$invalid; },
                    scheduleRefresh);
                scheduleRefresh();
            }
        },
    };
});
